import { defineQuery } from "@rocicorp/zero";
import { zql } from "../schema";

/**
 * Per-user UI flags (ephemeral acknowledgment/progress state). `forUser`
 * returns the caller's own flag rows — read authorization is the `ctx.sub`
 * filter (the sole read-auth layer; `definePermissions` is removed).
 */
export const uiFlagsQueries = {
  forUser: defineQuery(({ ctx: { sub } }) =>
    zql.user_ui_flags.where("user_id", sub),
  ),
};
